import $ from "jquery";

(() => {
  if (!$(".static-building").length) {
    return false;
  }

  const toggleBuildingImage = $(".js-toggle-building-image");

  toggleBuildingImage.on("click", function () {
    const targetId = $(this).data("floor");
    const dataIndex = $(this).data("index");
    const targetElement = $("#" + targetId);
    const targetSiblings = targetElement.siblings();
    const superParent = $(this).parents(".buildingOccupancy__box");
    const targetNumber = superParent.find(
      '.numberWrap span[data-index="' + dataIndex + '"]'
    );
    const floorTitle = $(this).attr("title");

    $(this).addClass("is-active");
    $(this).siblings().removeClass("is-active");

    targetNumber.addClass("is-active");
    targetNumber.siblings().removeClass("is-active");

    targetElement.addClass("is-active");
    targetSiblings.removeClass("is-active");

    $("#current-floor").text(floorTitle);
  });


  
})();
